import './bootstrap';
import '../css/app.css';
import { createApp } from 'vue';
import App from './components/App.vue';
import router from './router';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

const app = createApp(App);

const GlobalArabicPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#f4f6fb',
            100: '#e9edf6',
            200: '#d0d8ec',
            300: '#a8b8dc',
            400: '#758ec7',
            500: '#4766ae',
            600: '#38518a',
            700: '#2c406d',
            800: '#233357',
            900: '#1b2641',
            950: '#101728',
        },
    },
});

app.use(PrimeVue, {
    theme: {
        preset: GlobalArabicPreset,
        options: {
            ripple: true,
            // prefix: 'p',
            darkModeSelector: 'light',
        },
    },
});

app.use(router);

app.mount("#app");
